import { useTranslate } from '@growtherapy/i18n';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@growtherapy/sprout-ui';

export function ProviderNotHereModal({
  isOpen,
  onClose,
  onReportProviderNoShow,
  onMessageProvider,
  isProviderOnline,
}: {
  isOpen: boolean;
  onClose: () => void;
  onReportProviderNoShow: () => void;
  isProviderOnline: boolean;
  onMessageProvider: () => void;
}) {
  const t = useTranslate();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader>{t('telehealth-core:waitingRoom.isYourProviderNotHereLetUsKnow')}</ModalHeader>
      <ModalBody aria-live='polite'>
        {isProviderOnline
          ? t('telehealth-core:waitingRoom.yourProviderAppearsToBeOnline')
          : t('telehealth-core:waitingRoom.weNoticedYourProviderHasntShownUp')}
      </ModalBody>
      <ModalFooter
        actions={[
          {
            key: 'continue-waiting',
            use: 'secondary',
            onClick: onClose,
            actionContent: t('telehealth-core:waitingRoom.continueWaiting'),
          },
          {
            key: 'report-provider-no-show',
            use: 'primary',
            onClick: isProviderOnline ? onMessageProvider : onReportProviderNoShow,
            actionContent: isProviderOnline
              ? t('telehealth-core:waitingRoom.messageProvider')
              : t('telehealth-core:waitingRoom.yesMyProviderIsntHere'),
          },
        ]}
      />
    </Modal>
  );
}
